import { Trans, useTranslation } from '@frontend/i18n';
import { useTranslationTokens } from '@frontend/i18n-tokens';
import { Text } from '@frontend/design-system';

interface Props {
  totalCount?: number;
  selectedCount?: number;
  textColor?: string;
}

export const CountInfo = ({ totalCount, selectedCount, textColor }: Props) => {
  const { t } = useTranslation('schedule-quick-fill');
  const tokens = useTranslationTokens();
  if (!totalCount) return null;

  const contactsText = totalCount > 1 ? tokens.contacts : tokens.individualContact;
  return (
    <Text size='small' css={textColor && { color: textColor }}>
      {selectedCount ? (
        <Trans t={t} values={{ selectedCount, totalCount, contactsText: contactsText }}>
          <strong>{{ selectedCount }}</strong> {t('of')} <strong>{{ totalCount }}</strong> {{ contactsText }}{' '}
          {t('selected')}
        </Trans>
      ) : (
        `${totalCount} ${contactsText}`
      )}
    </Text>
  );
};
